import Table from '@/components/Table/Table.jsx'
import TableChooseProduct from '../_PRODUCT/TableChooseProduct.jsx'
import {useMapContext} from '@/components/MindMap/index.mjs'
import {useTableColumnBdName, useTableColumnBdNo} from '../BD/useTableColumnBd.jsx'

const TableChooseBd = (props) => {
    const map = useMapContext()
    const typeName = map.BizNode.BD.typeName(map)
    const {prjTypeCode, subTypeCode} = map.data

    const columns = [
        'BODA1' === subTypeCode && {
            title: '业务域',
            dataIndex: 'bmNamePath',
            component: <Table.ViewText />,
        },

        'BODA1' !== subTypeCode && {
            title: '功能域',
            dataIndex: 'fmNamePath',
            component: <Table.ViewText />,
        },

        {
            title: '子系统',
            dataIndex: 'ssName',
            component: <Table.ViewText />,
        },

        'BCT' === prjTypeCode && {
            title: '界面方案',
            dataIndex: 'uiCase',
            component: <Table.ViewText />,
        },

        useTableColumnBdName(),
        useTableColumnBdNo(),

        {
            title: `${typeName}类型`,
            dataIndex: 'bdTypeName',
            component: <Table.ViewText />,
        },
    ].filter(a => a)

    return (
        <TableChooseProduct
            columns={columns}
            {...props}
        />
    )
}

export default TableChooseBd
